import React from 'react'
import { useTranslation } from 'react-i18next'

import useDropdown from '../DropDown'
import { DropDown, FloatingMenu } from '../DropDown.styles'
import { NavButton } from './Navigation.styles'
import useStore from '../../hooks/useStore'

const LanguageNav = () => {
  const { state, dispatch } = useStore()
  const { lang } = state
  const langs = [
    {
      id: 'en',
      title: 'English'
    },
    {
      id: 'ar',
      title: 'عربي'
    }
  ]

  const {
    activeItem,
    menuItems,
    setSelected,
    opened,
    ...langsDropDown
  } = useDropdown({ active: lang, items: langs })

  const { i18n, t } = useTranslation('langMenu')

  return (
    <DropDown>
      {langsDropDown.renderToggleButton({
        label: activeItem ? t('title') : t('unset')
      })}
      <FloatingMenu opened={opened}>
        {menuItems.map(item => (
          <NavButton
            className="lang-button"
            onClick={() => {
              setSelected(item.id)
              i18n.changeLanguage(item.id)
              dispatch({
                type: 'switchLang',
                payload: item.id
              })
            }}
            key={item.id}
          >
            {item.title}
          </NavButton>
        ))}
      </FloatingMenu>
    </DropDown>
  )
}

export default LanguageNav
